import React from "react";
import ComingSoon from "../components/ComingSoon";

const NBAFreeAgency = () => {
  return <ComingSoon pageName="NBA Free Agency" />;
};

export default NBAFreeAgency;
